/** Textos da cobrança automática na lista e no detalhe (plano, seção 6.6). */

export const CHARGE_AUTOMATIC_BADGE = 'Automático';

/**
 * Linha do tempo: Enviada → Paga → Liberada → Na sua conta. Cada etapa
 * recebe a data e o detalhe (forma de pagamento, ••1234 do repasse) de quem
 * monta a tela — este texto só dá o rótulo fixo de cada etapa.
 */
export const CHARGE_TIMELINE_STEPS = {
  sent: 'Enviada',
  paid: 'Paga',
  released: 'Liberada',
  inAccount: 'Na sua conta',
};

export const CHARGE_AMOUNTS = {
  grossLabel: 'Bruto',
  feeLabel: 'Taxa',
  netLabel: 'Líquido',
  /** `feeAmount`/`netAmount` vêm `null` até o webhook `payment_intent.succeeded` confirmar o pagamento — nunca calculados aqui. */
  pending: '—',
};

export const CHARGE_ACTIONS = {
  /** Um botão só, manual ou automática — a API decide o que fazer em cada caso. */
  confirmReceipt: 'Confirmar recebimento',
  confirmReceiptBody: 'Você confirma que recebeu o pagamento desta cobrança?',
  confirmReceiptAutomaticBody:
    'Confirma que já recebeu esse pagamento direto do cliente (dinheiro, outro Pix)? Isso cancela a cobrança automática em aberto e marca esta cobrança como paga agora.',
  confirmReceiptSuccess: 'Recebimento confirmado.',
  confirmReceiptError: 'Não foi possível confirmar agora. Tente novamente.',
  refund: 'Devolver dinheiro',
  /** Explica prazo e taxa antes de abrir o formulário de reembolso numa cobrança automática. */
  refundAutomaticExplanation:
    'No Pix, dá para devolver até 90 dias depois do pagamento. No cartão, a devolução volta na fatura do cliente, no prazo do banco emissor. A taxa já cobrada não volta, mesmo com o reembolso.',
  refundBoletoUnavailable:
    'Boleto pago não tem devolução automática. Combine com o cliente e devolva por Pix.',
  /** Aviso informativo (não bloqueia — quem recusa de verdade é a API) quando o Pix já passou dos 90 dias. */
  refundPixOverdueWarning:
    'Esse Pix foi pago há mais de 90 dias — a devolução automática pode ser recusada.',
  /** Cobrança manual: o reembolso já é definitivo na resposta do `POST`. */
  refundSuccessMessage: 'Reembolso processado com sucesso!',
  /**
   * Cobrança automática (T2.5): o `POST /charge/:id/refund` devolve
   * `refundPending: true` — o Stripe foi acionado, mas quem confirma de
   * verdade é o webhook `charge.refunded`/`refund.updated`.
   */
  refundPendingMessage: 'Devolução pedida. O status desta cobrança muda quando ela for confirmada.',
  resend: 'Reenviar link',
  convertToAutomatic: 'Passar para automático',
  convertToAutomaticConfirmTitle: 'Passar para automático',
  convertToAutomaticConfirmBody:
    'O cliente passa a pagar direto pelo link, com Pix, cartão ou boleto (conforme o que você aceita). O pagamento é confirmado sozinho e o dinheiro segue para a sua conta.',
};

export const CHARGE_DISPUTE = {
  title: 'Contestação',
  /** Prazo e o texto de "o que fazer" entram pela tela — o assunto do cartão do Stripe já traz o prazo real. */
  body: 'O cliente contestou este pagamento com o banco dele. Veja o prazo para responder.',
};
